<template>
  <v-bottom-navigation
    v-model="activeItem"
    height="56"
    class="bottom-nav"
  >
    <v-btn
      v-for="item in menuItems"
      :key="item.value"
      :value="item.value"
      :to="item.to"
    >
      <v-icon>{{ item.icon }}</v-icon>
      <span>{{ item.title }}</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { useUserStore } from '@/stores/user'
import { API_BASE_URL } from '@/services/api'

const route = useRoute()
const userStore = useUserStore()
const activeItem = ref('overview')
const pendingCount = ref(0)

const baseItems = [
  { value: 'overview', to: '/overview', icon: 'mdi-chart-box', title: 'Обзор' },
  { value: 'payments', to: '/payments', icon: 'mdi-cash', title: 'Платежи' },
  { value: 'services', to: '/services', icon: 'mdi-sim', title: 'Сервисы' },
]

const menuItems = computed(() => {
  if (pendingCount.value > 0) {
    return [...baseItems, { value: 'requests', to: '/requests', icon: 'mdi-clipboard-text-clock', title: 'Заявки' }]
  }
  return baseItems
})

const fetchPendingCount = async () => {
  const phone = userStore.state?.context?.user?.phoneNumber?.substring(4) || ''
  if (!phone) return
  try {
    const { data } = await axios.get(`${API_BASE_URL}/requests/pending?phone=${phone}`)
    pendingCount.value = data.count || 0
  } catch (e) {
    // silent
  }
}

watch(() => userStore.state.value, (state) => {
  if (state === 'authenticated') {
    fetchPendingCount()
    setInterval(fetchPendingCount, 30000)
  }
}, { immediate: true })

watch(() => route.path, (newPath) => {
  const item = menuItems.value.find(item => item.to === newPath)
  if (item) {
    activeItem.value = item.value
  }
}, { immediate: true })
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

:deep(.v-btn) {
  letter-spacing: normal !important;
  height: 100% !important;
}

:deep(.v-btn__content) {
  flex-direction: column;
  line-height: 1.2;
}

:deep(.v-icon) {
  margin-bottom: 4px;
}
</style>
